import { backendHostName } from "@/utilities/constants";

export class UnAuthenticatedError extends Error {}

export class UnAuthorizedError extends Error {}

export class NoContentResponse {}

export class ErrorResponse extends Error {
  public statusCode: number;

  constructor(statusCode: number) {
    super();

    this.statusCode = statusCode;
  }
}

export const fetchApiRaw = async (url: string, options: RequestInit): Promise<Response> => {
  const request = new Request(`${backendHostName}/api${url}`, options);
  return fetch(request);
};

export const fetchApi = async <T>(url: string, options: RequestInit): Promise<T> => {
  const response = await fetchApiRaw(url, options);

  if (response.status === 401) {
    throw new UnAuthenticatedError();
  }

  if (response.status === 403) {
    throw new UnAuthorizedError();
  }

  if (response.status >= 400) {
    throw new ErrorResponse(response.status);
  }

  if (response.status === 204) {
    // use exception system since this is an exceptional control flow that must
    // be explicitly handled.
    throw new NoContentResponse();
  }

  const json = await response.json();

  return json as T;
};
